import {
  HIDE_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER,
  HIDE_REPORT_LOADER,
  SET_COUNT_BY_APP,
  SET_COUNT_BY_CLIENT,
  SET_COUNT_BY_MEDIABUYER,
  SET_COUNT_BY_OFFER,
  SET_ERROR_REPORT_LOADER,
  SET_MANAGERS_REPORT_DATE,
  SET_NON_CAHORT_REPORT_DATE,
  SET_PAYMENT_COST_INSPECTION_DATE,
  SET_PAYMENT_COST_INSPECTION_REPORT_FILTERS,
  SET_PAYMENT_COST_INSPECTION_REPORT_LIST,
  SET_QUALITY_BANNER_STATS,
  SET_QUALITY_CAMP_STATS,
  SET_QUALITY_EVENTS,
  SET_QUALITY_FILTERS,
  SET_QUALITY_MEDIA_SOURCE,
  SET_QUALITY_TABLE,
  SET_QUALITY_WIDGETS,
  SET_REPORT_CAMPAIGNS_COUNT_BY,
  SET_TOP_MANAGEMENT_APP_PROFIT,
  SET_TOP_MANAGEMENT_CLIENT_SPEND,
  SET_TOP_MANAGEMENT_DATE,
  SET_TOP_MANAGEMENT_MEDIABUYER_PROFIT,
  SET_TOP_MANAGEMENT_MEDIABUYER_SPEND,
  SET_TOP_MANAGEMENT_MEDIABUYER_STATS,
  SET_TOP_MANAGEMENT_OFFER_PROFIT,
  SET_TOP_MANAGEMENT_PROFIT,
  SHOW_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER,
  SHOW_REPORT_LOADER,
  WIDGET_LOADER,
  SET_QUALITY_CAMP_STAT_LOADER,
  SET_MEDIA_SOURCE_LOADER,
  SET_QUALITY_ADGROUPS_STATS,
  SET_QUALITY_ADGROUPS_STAT_LOADER,
  SET_REPORT_RENT_STATS,
  SET_REPORT_RENT_WIDGETS,
  SET_REPORT_RENT_STATS_LOADER,
  SET_REPORT_RENT_WIDGETS_LOADER,
} from "./actionTypes";
import { getInitialDate } from "../../helpers/utils";

const INIT_STATE = {
  camp_stats: {
    count: 0,
    page: 1,
    tracker_app_id: null,
    start_date: "2021-11-11",
    end_date: "2021-12-12",
    sizePerPage: 10,
    results: [],
  },
  banner_stats: {
    count: 0,
    page: 1,
    campaign_id: null,
    start_date: "2021-11-11",
    end_date: "2021-12-12",
    sizePerPage: 10,
    results: [],
  },
  adgroups_stats: {
    count: 0,
    page: 1,
    tracker_app_id: null,
    start_date: "2021-11-11",
    end_date: "2021-12-12",
    sizePerPage: 10,
    results: [],
  },
  mediaBuyerProfit: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  offerProfit: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  profit: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  mediaBuyerStats: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  mediaBuyerSpend: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  clientSpend: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  appProfit: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  campaignCountBy: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  countByApp: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  countByOffer: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  countByClient: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  countByMediaBuyer: {
    start_date: "2021-11-11",
    end_date: "2021-12-12",
  },
  mediaSourceStats: {
    results: [],
  },
  managersDate: null,
  nonCahortDate: {
    start_date: getInitialDate("start_date", new Date(new Date().setDate(1))),
    end_date: getInitialDate("end_date"),
  },
  topManagementDate: null,
  quality_filters: {},
  quality_widgets: null,
  quality_table: null,
  quality_events: [],
  inspection_data: {
    count: 0,
    next: null,
    previous: null,
    page: 0,
    sizePerPage: 0,
  },
  inspectionDate: null,
  inspection_filters: {
    offers: [],
    media_sources: [],
  },
  reportRentData: {
    count: 0,
    page: 1,
    start_date: "2023-01-01",
    end_date: "2023-01-01",
    sizePerPage: 10,
    results: [],
  },
  reportRentWidgets: [
    {
      icon: "mdi mdi-eye-check-outline",
      title: "Impressions",
      value: 0,
      badgeValue: `Undefined`,
      color: "danger",
      desc: "From previous period",
      type: "WITH_DIFFERENCE",
    },
    {
      icon: "mdi mdi-cursor-default-click-outline",
      title: "Clicks",
      value: 0,
      badgeValue: `Undefined`,
      color: "danger",
      desc: "From previous period",
      type: "WITH_DIFFERENCE",
    },
    {
      icon: "mdi mdi-contactless-payment-circle-outline",
      title: "Payment",
      value: 0,
    },
    {
      icon: "mdi mdi-cash-100",
      title: "Spend",
      value: 0,
    },
    {
      icon: "mdi mdi-cash-plus",
      title: "Profit",
      value: 0,
    },
  ],
  rent_stats_loader: false,
  rent_widgets_loader: false,
  loading_inspection_data: false,
  loading: false,
  quality_stats_loader: false,
  media_source_loader: false,
  adgroups_stats_loader: false,
  widget_loader: false,
  error: null,
};

const Reporting = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_QUALITY_TABLE:
      return {
        ...state,
        quality_table: action.payload,
      };
    case SET_MANAGERS_REPORT_DATE:
      return {
        ...state,
        managersDate: action.payload,
      };
    case SET_NON_CAHORT_REPORT_DATE:
      return {
        ...state,
        nonCahortDate: action.payload,
      };
    case SET_TOP_MANAGEMENT_DATE:
      return {
        ...state,
        topManagementDate: action.payload,
      };
    case SET_QUALITY_MEDIA_SOURCE:
      return {
        ...state,
        mediaSourceStats: {
          results: action.payload,
        },
      };
    case SET_COUNT_BY_APP:
      return {
        ...state,
        countByApp: action.payload,
      };
    case SET_COUNT_BY_OFFER:
      return {
        ...state,
        countByOffer: action.payload,
      };
    case SET_COUNT_BY_MEDIABUYER:
      return {
        ...state,
        countByMediaBuyer: action.payload,
      };
    case SET_COUNT_BY_CLIENT:
      return {
        ...state,
        countByClient: action.payload,
      };
    case SET_TOP_MANAGEMENT_CLIENT_SPEND:
      return {
        ...state,
        clientSpend: action.payload,
      };
    case SET_QUALITY_EVENTS:
      return {
        ...state,
        quality_events: action.payload,
      };
    case SET_REPORT_CAMPAIGNS_COUNT_BY:
      return {
        ...state,
        campaignCountBy: action.payload,
      };
    case SET_TOP_MANAGEMENT_MEDIABUYER_STATS:
      return {
        ...state,
        mediaBuyerStats: action.payload,
      };
    case SET_TOP_MANAGEMENT_APP_PROFIT:
      return {
        ...state,
        appProfit: action.payload,
      };
    case SET_TOP_MANAGEMENT_MEDIABUYER_SPEND:
      return {
        ...state,
        mediaBuyerSpend: action.payload,
      };
    case SET_QUALITY_CAMP_STATS:
      return {
        ...state,
        camp_stats: action.payload,
      };
    case SET_QUALITY_ADGROUPS_STATS:
      return {
        ...state,
        adgroups_stats: action.payload,
      };
    case SET_QUALITY_BANNER_STATS:
      return {
        ...state,
        banner_stats: action.payload,
      };
    case SET_QUALITY_FILTERS:
      return {
        ...state,
        quality_filters: action.payload,
      };
    case SET_QUALITY_WIDGETS:
      return {
        ...state,
        quality_widgets: action.payload,
      };
    case SET_TOP_MANAGEMENT_PROFIT:
      return {
        ...state,
        profit: action.payload,
      };
    case SET_TOP_MANAGEMENT_MEDIABUYER_PROFIT:
      return {
        ...state,
        mediaBuyerProfit: action.payload,
      };
    case SET_TOP_MANAGEMENT_OFFER_PROFIT:
      return {
        ...state,
        offerProfit: action.payload,
      };
    case SET_PAYMENT_COST_INSPECTION_REPORT_LIST:
      return {
        ...state,
        inspection_data: action.payload,
      };
    case SET_PAYMENT_COST_INSPECTION_DATE:
      return {
        ...state,
        inspectionDate: action.payload,
      };
    case SET_PAYMENT_COST_INSPECTION_REPORT_FILTERS:
      return {
        ...state,
        inspection_filters: action.payload,
      };
    case SHOW_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER:
      return {
        ...state,
        loading_inspection_data: true,
      };
    case HIDE_PAYMENT_COST_INSPECTION_REPORT_LIST_LOADER:
      return {
        ...state,
        loading_inspection_data: false,
      };
    case SHOW_REPORT_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_REPORT_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_ERROR_REPORT_LOADER:
      return {
        ...state,
        isError: action.payload,
      };
    case WIDGET_LOADER:
      return {
        ...state,
        widget_loader: !state.widget_loader,
      };
    case SET_QUALITY_CAMP_STAT_LOADER:
      return {
        ...state,
        quality_camp_stats_loader: !state.quality_camp_stats_loader,
      };
    case SET_MEDIA_SOURCE_LOADER:
      return {
        ...state,
        media_source_loader: !state.media_source_loader,
      };
    case SET_REPORT_RENT_STATS:
      return {
        ...state,
        reportRentData: action.payload,
      };
    case SET_REPORT_RENT_WIDGETS:
      return {
        ...state,
        reportRentWidgets: action.payload,
      };
    case SET_REPORT_RENT_STATS_LOADER:
      return {
        ...state,
        rent_stats_loader: !state.rent_stats_loader,
      };
    case SET_REPORT_RENT_WIDGETS_LOADER:
      return {
        ...state,
        rent_widgets_loader: !state.rent_widgets_loader,
      };
    case SET_QUALITY_ADGROUPS_STAT_LOADER:
      return {
        ...state,
        adgroups_stats_loader: !state.adgroups_stats_loader,
      };
    default:
      return state;
  }
};

export default Reporting;
